var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTgCommunity(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 38,
    viewBox: "0 0 40 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: -2,
    width: 40,
    height: 40,
    rx: 5,
    fill: "#9583FF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.306 16.888C15.4072 14.6302 18.808 13.1416 20.5084 12.4224C25.3691 10.3689 26.3779 10.0122 27.0367 10.0001C27.1816 9.99774 27.5042 10.0341 27.7147 10.207C27.8896 10.3529 27.9388 10.5501 27.9634 10.6886C27.9853 10.8269 28.0154 11.1422 27.9908 11.3883C27.7283 14.1994 26.5884 21.021 26.0088 24.1696C25.7655 25.5018 25.2816 25.9485 24.8141 25.9921C23.7972 26.0871 23.0262 25.3099 22.0421 24.6546C20.503 23.6288 19.6336 22.9904 18.1382 21.9896C16.4105 20.8329 17.5313 20.1971 18.5155 19.1582C18.7725 18.8863 23.2504 14.7488 23.3352 14.3735C23.3461 14.3266 23.357 14.1516 23.2531 14.0594C23.152 13.9669 23.0016 13.9985 22.8923 14.0235C22.7365 14.0591 20.2788 15.7113 15.5111 18.9799C14.814 19.4671 14.1825 19.7046 13.6138 19.6921C12.9905 19.6785 11.7877 19.3332 10.8937 19.0382C9.80021 18.6763 8.92814 18.4849 9.00468 17.8702C9.04295 17.5502 9.47763 17.2227 10.306 16.888Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTgCommunity);
export default __webpack_public_path__ + "static/media/TG-Community.27df0415ea81214e2a40268035f0f56f.svg";
export { ForwardRef as ReactComponent };